module.exports = __webpack_public_path__ + "images/stern9dac0b994b42ce85fb6a6b4bec484de7.png";